/**
 * Delay selected scripts until the first user interaction to improve initial page performance.
 * ------------------------------
 * External Script Example:
 * <script delay="{{ 'tidio.js' | asset_url }}"></script>
 * ------------------------------
 * Inline Script Example:
 * <script type="text/plain" data-delay>
 *   console.log('Runs after interaction');
 * </script>
 * ------------------------------
 * Recommended placement:
 * Right before the closing </body> tag.
 */
(function () {
  const delayedScripts = document.querySelectorAll('script[delay]');
  if (!delayedScripts.length) return;

  const events = ['keydown','mousemove','wheel','touchstart','touchmove'];

  function loadScripts() {
    events.forEach(e =>
      window.removeEventListener(e, loadScripts, { passive: true })
    );

    delayedScripts.forEach(original => {
      if (original.dataset.loaded) return;
      original.dataset.loaded = "true";

      const newScript = document.createElement('script');
      const delayedSrc = original.getAttribute('delay');

      if (delayedSrc) {
        newScript.src = delayedSrc;
      } else {
        newScript.textContent = original.textContent;
      }

      // Preserve module if used
      if (original.type === 'module') {
        newScript.type = 'module';
      }

      document.body.appendChild(newScript);
    });
  }

  events.forEach(e =>
    window.addEventListener(e, loadScripts, { passive: true, once: true })
  );
})();

/**
 * Shopify Form popup customization
 */
const mmGiveawayObserver = new MutationObserver(() => {
  const container = document.querySelector("#app-embed-container-859056"); // Must be the form id
  if (container) {
    const shadowRoot = container.shadowRoot;
    if (!shadowRoot) return;
    
    mmGiveawayInjectStyles(shadowRoot);
    mmGiveawayObserver.disconnect(); // Stop observing once container is found
  }
});

// Start observing the container
mmGiveawayObserver.observe(document.body, { childList: true });
setTimeout(() => mmGiveawayObserver.disconnect(), 7000); // Stop observing after 7 seconds if the container is never found

function mmGiveawayInjectStyles(shadowRoot) {
  const style = document.createElement("STYLE");
  style.innerHTML = `:host {
--heading-text-color: #DD0000;
--button-text-color: #FFFFFF;
}
[class^="_teaserContainer_"] {
  padding: 14px !important;
}
[class^="_teaserHeading_"] {
  font-size: clamp(1.2rem, 2vw + 1rem, 1.75rem) !important;
}
[class^="_formHeader_"] {
  margin: 0 auto 19px !important;
}
[class^="_textBody_"] {
  font-size: 13px !important;
}`;
  shadowRoot.appendChild(style);
}

/**
 * Localization
 * TODO: Guide users outside US to the Language Form or set things up on DNS level like shopify.com
 */
